import { normalizeUserEntity } from '../User';

import {
  ActivityKind,
  CommentActivityEntity,
  CommentActivityEntityApi,
  EditActivityEntity,
  EditActivityEntityApi,
  StatusChangeEntity,
  StatusChangeEntityApi,
} from './entities';
import { TableCellActivityEntity, TableCellActivityEntityApi } from './entity';

const normalizeCommentEntity = (
  raw: TableCellActivityEntityApi
): CommentActivityEntity | null => {
  if (raw.type === ActivityKind.comment) {
    return {
      isEdited: (raw.extra as CommentActivityEntityApi).is_edited,
      value: (raw.extra as CommentActivityEntityApi).value,
    };
  }

  return null;
};

const normalizeEditsEntity = (
  raw: TableCellActivityEntityApi
): EditActivityEntity[] | null => {
  if (raw.type === ActivityKind.change) {
    return (raw.extra as { changes: EditActivityEntityApi[] }).changes.map(
      (item) => ({
        prevValue: item.prev_value,
        currValue: item.curr_value,
        columnId: item.column_id,
        formFieldId: item.column_id,
        icons: item.icons,
        label: '',
      })
    );
  }

  return null;
};

const normalizeStatusChangeEntity = (
  raw: TableCellActivityEntityApi
): StatusChangeEntity | null => {
  if (raw.type === ActivityKind.status_change) {
    const extra = raw.extra as StatusChangeEntityApi;
    return {
      statusType: extra.status_type,
      prevStatus: extra.prev_status,
      currStatus: extra.curr_status,
      triggeredByRecordId: extra.triggered_by_record_id,
      triggeredByUserName: extra.triggered_by_user_name,
      isDirectChange: extra.is_direct_change,
    };
  }

  return null;
};

export const normalizeTableCellActivityEntity = (
  raw: TableCellActivityEntityApi
): TableCellActivityEntity => ({
  author: normalizeUserEntity(raw.author),
  id: raw.id,
  createdAt: new Date(raw.created_at),
  comment: normalizeCommentEntity(raw),
  edits: normalizeEditsEntity(raw),
  statusChange: normalizeStatusChangeEntity(raw),
  type: raw.type,
});
